<form [formGroup]="paymentConfirmationForm" class="send-payment-form">
    <div class="row">
        <div class="dialog-title">
            <span class="text-fw-700">Payment confirmation</span>
        </div>
    </div>

    <div class="row">
        <div class="col-6 pl-0">
            <div class="detail-info">
                <div class="confirm-label">You are sending</div>
                <div class="confirm-info">
                    <span>{{ paymentModel.currency.code }}</span>&nbsp;
                    <span>{{ paymentModel.amount | transformNumber }}</span>
                </div>
            </div>
        </div>
        <div class="col-6 pr-0">
            <div class="detail-info">
                <div class="confirm-label">Reason for payment</div>
                <div class="confirm-info">{{ paymentModel.reasonPayment.name === 'Others' ?
                    paymentModel.reasonPaymentOther : paymentModel.reasonPayment.name
                    }}
                </div>
            </div>
        </div>
    </div>

    <div class="row confirm-row">
        <div class="col-6 pl-0">
            <div class="detail-info">
                <div class="confirm-label">To beneficiary</div>
                <div class="confirm-info">{{ paymentModel.selectedRecipient.name }}</div>
            </div>
        </div>
        <div class="col-6 pr-0">
            <div class="detail-info">
                <div class="confirm-label">Bank name</div>
                <div class="confirm-info">{{ bankAccount?.name }}&nbsp;</div>
            </div>
        </div>
    </div>

    <div class="row confirm-row">
        <div class="col-6 pl-0">
            <div class="detail-info">
                <div class="confirm-label">Payment date</div>
                <div class="confirm-info">{{ paymentModel.paymentDate | date : 'dd/MM/yyyy' }}</div>
            </div>
        </div>
        <div class="col-6 pr-0">
            <div class="detail-info">
                <div class="confirm-label">IBAN/account number</div>
                <div class="confirm-info"> {{ bankAccount?.iBan ? bankAccount?.iBan : bankAccount?.accountNumber
                    }}&nbsp;</div>
            </div>
        </div>
    </div>

    <div class="row confirm-row">
        <div class="col-6 pl-0">
            <div class="detail-info"
                [ngClass]="{'error': paymentConfirmationForm.get('paymentReference') && !paymentConfirmationForm.get('paymentReference').valid && paymentConfirmationForm.get('paymentReference').touched}">
                <div class="confirm-label"
                    [ngClass]="{'error': paymentConfirmationForm.get('paymentReference') && !paymentConfirmationForm.get('paymentReference').valid && paymentConfirmationForm.get('paymentReference').touched}">
                    Payment reference</div>
                <div class="confirm-info d-flex">
                    <input formControlName="paymentReference" maxlength="70" />
                    <div class="img ml-auto d-flex">
                        <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-dark.svg" alt="" />
                        <span class="send-payment-tooltip tooltip-right">This is what will appear on the
                            <br>beneficiary’s bank statement</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 pr-0">
            <div class="detail-info">
                <div class="confirm-label">SWIFT code</div>
                <div class="confirm-info">{{ bankAccount?.sWiftCode }}&nbsp;</div>
            </div>
        </div>
    </div>

    <div class="row confirm-row"
        *ngIf="paymentConfirmationForm.get('paymentReference') && paymentConfirmationForm.get('paymentReference').hasError('required') && paymentConfirmationForm.get('paymentReference').touched">
        <div class="col-12 pl-0 error-message">
            Please input information here
        </div>
    </div>
    <div class="row confirm-row"
        *ngIf="paymentConfirmationForm.get('paymentReference') && paymentConfirmationForm.get('paymentReference').hasError('maxlength') && paymentConfirmationForm.get('paymentReference').touched">
        <div class="col-12 pl-0 error-message">
            Maximum of 70 characters
        </div>
    </div>
    <div class="row confirm-row"
        *ngIf="paymentConfirmationForm.get('paymentReference') && paymentConfirmationForm.get('paymentReference').hasError('pattern') && paymentConfirmationForm.get('paymentReference').touched">
        <div class="col-12 pl-0 error-message">
            <np-swift-character-message></np-swift-character-message>
        </div>
    </div>

    <div class="row confirm-row">
        <div class="col-6 pl-0">
            <div class="detail-info">
                <div class="confirm-label">External Payment ID</div>
                <div class="confirm-info d-flex">
                    <input formControlName="externalPaymentId" maxlength="20" />
                    <div class="img ml-auto d-flex">
                        <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-dark.svg" alt="" />
                        <span class="send-payment-tooltip tooltip-right">Add your payment id here
                            <br>if you want to use it for tracking the payment</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 pr-0" *ngIf="paymentCodes.length > 0">
            <div class="detail-info"
                [ngClass]="{'error': paymentConfirmationForm.get('paymentCode') && !paymentConfirmationForm.get('paymentCode').value && paymentConfirmationForm.get('paymentCode').touched}">
                <div class="confirm-label"
                    [ngClass]="{'error': paymentConfirmationForm.get('paymentCode') && !paymentConfirmationForm.get('paymentCode').value && paymentConfirmationForm.get('paymentCode').touched}">
                    Purpose of payment</div>
                <div class="confirm-info d-flex">

                    <mat-form-field class="no-padding">
                        <input type="text" formControlName="paymentCode" matInput [matAutocomplete]="auto"
                            class="input-upper-case" (focus)="paymentCodeExist = true">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let purposeOfPayment of filteredOptions | async"
                                [value]="purposeOfPayment.code"
                                matTooltip="{{ purposeOfPayment.code }} - {{ purposeOfPayment.description }}"
                                matTooltipClass="custom-mat-tooltip" [matTooltipPosition]="'below'">
                                {{ purposeOfPayment.code }} - {{ purposeOfPayment.description }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="paymentCodes.length > 0">
        <div class="row confirm-row"
            *ngIf="paymentConfirmationForm.get('paymentCode') && !paymentConfirmationForm.get('paymentCode').value && paymentConfirmationForm.get('paymentCode').touched">
            <div class="col-12 pl-0 error-message">
                Please input information here
            </div>
        </div>
        <div class="row confirm-row"
            *ngIf="paymentConfirmationForm.get('paymentCode') && paymentConfirmationForm.get('paymentCode').value && paymentConfirmationForm.get('paymentCode').touched && !paymentCodeExist">
            <div class="col-12 pl-0 error-message">
                Please select from the Purpose of Payment list
            </div>
        </div>
    </ng-container>

    <div class="row confirm-row"
        *ngIf="paymentConfirmationForm.get('externalPaymentId') && paymentConfirmationForm.get('externalPaymentId').hasError('maxlength') && paymentConfirmationForm.get('externalPaymentId').touched">
        <div class="col-12 pl-0 error-message">
            Maximum of 20 characters
        </div>
    </div>
    <div class="row confirm-row"
        *ngIf="paymentConfirmationForm.get('externalPaymentId') && paymentConfirmationForm.get('externalPaymentId').hasError('pattern') && paymentConfirmationForm.get('externalPaymentId').touched">
        <div class="col-12 pl-0 error-message">
            <np-swift-character-message></np-swift-character-message>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-4 pl-0">
            <button class="btn btn-block btn-lg btn-greengo-o" (click)="goBack()">Cancel</button>
        </div>
        <div class="ml-auto">
            <button class="btn btn-lg" [ngClass]="{
                  'btn-greengo': paymentConfirmationForm.valid,
                  'btn-inactive': !paymentConfirmationForm.valid
                }" (click)="payNow()" npFocusOutClicked>
                <ng-container *ngIf="registerService.dualAuthorization">Send for approval</ng-container>
                <ng-container *ngIf="!registerService.dualAuthorization">Make payment</ng-container>
            </button>
        </div>
    </div>
</form>